// AppRefreshActions.js

import { FaSync } from "react-icons/fa";
import styles from "./AppRefreshActions.module.css";

export const AppRefreshButton = ({ refreshFunction }) => {
  return (
    <button className={styles.appRefreshButton} onClick={refreshFunction}>
      <FaSync />
      Sync
    </button>
  );
};
